import React from "react";

const IconPhone = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 9.524 9.525"
    >
      <path
        d="M3,3.947A.947.947,0,0,1,3.947,3H5.5a.474.474,0,0,1,.449.324l.709,2.128a.474.474,0,0,1-.238.573L5.352,6.56A5.229,5.229,0,0,0,7.964,9.172L8.5,8.1a.474.474,0,0,1,.573-.238l2.128.709a.474.474,0,0,1,.324.449v1.553a.947.947,0,0,1-.947.947H10.1A7.1,7.1,0,0,1,3,4.421Z"
        transform="translate(-2.5 -2.5)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
    </svg>
  );
};

export default IconPhone;
